import withAemIntegration from "../../../withAemIntegration";
import { lazy } from "@loadable/component";
const Component = lazy(
  () => import("@lexus.com/ui/dist/modules/FormBuilder"),
  {
    resolveComponent: (comp) => comp.SelectInput,
  }
);

const DropDownEditConfig = {
  emptyLabel: "Drop Down",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const transformData = (props = {}) => {
  return {
    ...props,
    required: !props.optional,
    maxOptions: props.numAllowedSelections,
    maxOptionsMsg: props.selectionLimitMessage,
    options: props.options?.map((option) => ({
      value: option.value,
      displayValue: option.name,
      isFixed: option.preselected,
    })),
  };
};

const DropDown = (props) => {
  const data = transformData(props);
  return <Component {...data} />;
};

export default withAemIntegration("lexus/components/form-builder/dropdown")(
  DropDown,
  DropDownEditConfig
);
